import $ from 'jquery'
import './styles'

export default class {
    constructor(params) {
        this.settings = Object.assign({}, this.defaults(), params)
        this.settings.baseObj = $(this.settings.columnsSelector)
        this.settings.addObj = this.settings.baseObj.next(`.${this.settings.addBtnClass}`)
        this.setColumnObj()
        this.setAddAction()
        this.addLimitChkAction()
    }
    defaults() {
        return {
            baseObj: null,
            columnsSelector: '.columns',
            addBtnClass: 'add-column',
            delBtnClass: 'del',
            maxSize: -1,
            editTmplFunc: false,

        }
    }
    setColumnObj() {
        this.settings.baseObj.children().each((idx, element) => {
            this.setDelAction($(element))
        })

        // カラムを作成
        let columnObj = this.settings.baseObj.children().first().clone()
        this.clearForm(columnObj)
        if(this.settings.editTmplFunc){
            this.settings.editTmplFunc(columnObj)
        }
        this.settings.columnObj = columnObj
    }
    setAddAction() {
        if (this.settings.maxSize > 0 && this.settings.maxSize <= this.settings.baseObj.children().length) {
            this.settings.addObj.addClass('hide').hide()
        }
        this.settings.addObj.on('click', event => {
            if (this.settings.maxSize > 0 && this.settings.maxSize <= this.settings.baseObj.children().length) {
                return false
            }
            const tmpColumn = this.settings.columnObj.clone()
            this.setDelAction(tmpColumn)
            this.settings.baseObj.append(tmpColumn)
            this.addLimitChkAction()
            if (this.settings.maxSize > 0 && this.settings.maxSize <= this.settings.baseObj.children().length) {
                this.settings.addObj.addClass('hide').hide()
            }
            this.changeAfter(this.settings.baseObj, "add", tmpColumn)
            return false
        })
    }
    setDelAction(obj) {
        obj.find(`> .${this.settings.delBtnClass}`).on('click', event => {
            $(event.currentTarget).parent().remove()
            this.addLimitChkAction()
            this.settings.addObj.removeClass('hide').show()
            this.changeAfter(this.settings.baseObj, "del", obj)
        })
    }
    clearForm(obj) {
        obj
            .find("input, select, textarea")
            .not(":button, :submit, :reset")
            .val("")
            .prop("checked", false)
            .prop("selected", false)
    }
    addActionAfter() {
        return false
    }
    delActionAfter() {
        return false
    }
    addLimitChkAction() {}
    changeAfter() {}
}
